export default __webpack_public_path__ + "static/media/bridge.e9a65bce.svg";